import { SERVER_URL } from '../../../constants';
import {
  fetchGetAuth,
  fetchPostAuth,
  fetchRemoveAuth
} from '../../../util/FetchUtil';

const controller = 'comunicado-turma/';

const findByComunicado = (codComunicado) => {
  const url = SERVER_URL + controller + 'comunicado/' + codComunicado;
  return fetchGetAuth(url);
}

const save = (comunicadoTurma) => {
  const url = SERVER_URL + controller;
  return fetchPostAuth(url, comunicadoTurma);
}

const remove = (codComunicado) => {
  const url = SERVER_URL + controller + codComunicado;
  return fetchRemoveAuth(url);
}

export {
  findByComunicado,
  save,
  remove,
}